export const FAQ_ITEMS = [
  {
    q: "Siete una chiesa?",
    a: "No. Tempio Vivo è un progetto di coaching cristiano e crescita integrata.",
  },
  {
    q: "Siete evangelici?",
    a: "Sì. Il progetto nasce da una visione cristiana evangelica.",
  },
  {
    q: "Siete una setta?",
    a: "No. La partecipazione è volontaria e non richiede di lasciare la propria chiesa o interrompere relazioni personali.",
  },
  {
    q: "Siete mormoni?",
    a: "No. Tempio Vivo non appartiene alla Chiesa di Gesù Cristo dei Santi degli Ultimi Giorni.",
  },
  {
    q: "Siete pastori o sacerdoti?",
    a: "No. Elio e Chiara sono i fondatori del progetto e non si presentano come pastori o sacerdoti.",
  },
  {
    q: "Posso partecipare se sono cattolico?",
    a: "Sì. Il progetto è aperto anche a persone cattoliche interessate alla crescita cristiana.",
  },
  {
    q: "Posso entrare se mi sto avvicinando alla fede?",
    a: "Sì. Sono presenti contenuti adatti anche a chi desidera conoscere meglio Gesù e la Bibbia.",
  },
  {
    q: "Devo lasciare la mia chiesa?",
    a: "No. Tempio Vivo non sostituisce la comunità cristiana locale.",
  },
  {
    q: "Qual è la differenza tra un coach cristiano e un pastore?",
    a: "Il coach cristiano accompagna la persona nel lavoro su obiettivi, convinzioni, decisioni e abitudini. Il pastore svolge un ruolo di guida spirituale nella propria comunità.",
  },
  {
    q: "Sostituite psicologi o psicoterapeuti?",
    a: "No. Il coaching non sostituisce diagnosi, psicoterapia o trattamenti sanitari.",
  },
  {
    q: "Con il piano App posso interagire con altri cristiani?",
    a: "Sì. Il piano App include social interno, pubblicazione di post e immagini, interazioni e chat tematiche.",
  },
  {
    q: "Posso accedere alle chat single e coppie con il piano App?",
    a: "Sì. Le chat tematiche interne sono incluse nel piano App.",
  },
  {
    q: "Qual è la differenza tra App e Community Coaching?",
    a: "Il piano Community Coaching comprende tutto il piano App e aggiunge incontri settimanali, gruppo WhatsApp privato e contatto diretto con Elio e Chiara.",
  },
  {
    q: "Posso contattare direttamente Elio e Chiara?",
    a: "Il contatto diretto tramite WhatsApp per domande e chiarimenti è previsto per i membri della Community Coaching, compatibilmente con i tempi di risposta dei fondatori.",
  },
  {
    q: "Devo parlare durante gli incontri?",
    a: "No. Puoi partecipare anche ascoltando.",
  },
  {
    q: "Il pagamento è sicuro?",
    a: "Il pagamento viene gestito attraverso Stripe Checkout, senza dover comunicare i dati della carta ai fondatori o ai coach.",
  },
  {
    q: "Cosa succede dopo il pagamento?",
    a: "Elio o un coach di Fede & Fitness Italia ti contatterà per aiutarti ad attivare l'accesso al percorso acquistato.",
  },
  {
    q: "Ricevo subito l'accesso?",
    a: "L'attivazione viene gestita con il supporto del team e non è necessariamente immediata.",
  },
  {
    q: "Devo acquistare entrambi gli abbonamenti?",
    a: "No. Il piano Community Coaching comprende già tutti i contenuti del piano App.",
  },
  {
    q: "Posso cancellare l'abbonamento?",
    a: "Sì. Puoi interrompere i rinnovi futuri seguendo le modalità previste dalle condizioni dell'abbonamento.",
  },
];
